import { render, staticRenderFns } from "./FollowBtn.vue?vue&type=template&id=f30d8e84&scoped=true&"
import script from "@/scripts/QA/Question/components/FollowBtn?vue&type=script&lang=js&"
export * from "@/scripts/QA/Question/components/FollowBtn?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30d8e84",
  null
  
)

export default component.exports